const EditUserFieldsNoPs = (editingUser,handleCheckBox) => {

  const getPlaceHolder = (field) => {
    if (editingUser.pharmacy) {
      return editingUser.pharmacy[field];
    } else {
      return '';
    }
  };

  const fields = [
    {
      item: {
        label: 'Nombre de la farmácia',
        name: 'name',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese el nombre de la farmácia',
          },
        ],
        initialValue: getPlaceHolder('name')
      },
      input: {  },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Nombre del dueño',
        name: 'owner',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese nombre del dueño de la farmácia',
          },
        ],
        initialValue: getPlaceHolder('owner')
      },
      input: {  },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Número de teléfono',
        name: 'cellPhone',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese un número de teléfono',
          },
        ],
        initialValue: getPlaceHolder('cellPhone')
      },
      input: { },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Número de teléfono del responsable de compras',
        name: 'responsibleCellPhone',
        rules: [
          {
            required: true,
            message:
              'Por favor ingrese un número de teléfono del responsable de compras',
          },
        ],
        initialValue: getPlaceHolder('responsibleCellPhone')
      },
      input: {  },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Nombre del responsable de compras',
        name: 'nameResponsible',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese el nombre del responsable de compras',
          },
        ],
        initialValue: getPlaceHolder('nameResponsible')
      },
      input: {  },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Email',
        name: 'email',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese un email',
          },
        ],
        initialValue: getPlaceHolder('email')
      },
      input: {  },
      inputTag: 'Input',
    },
    {
      item: {
        label: '¿Desea cambiar la contraseña?',
      },
      input: {
        onChange: handleCheckBox,
        id: 'adCheckbox',
      },
      inputTag: 'Checkbox',
    },
  ];
  return fields;
};

export default EditUserFieldsNoPs;
